import axios from "axios";

export const UpdateTheoryApi = async (theoryUpdate, token) => {
  try {
    const BASED_URL = process.env.REACT_APP_BASED_URL;
    const path = "/admin/theory/update?";
    const endpoint = `${BASED_URL}${path}token=${token}`;
    const response = await axios.put(endpoint, theoryUpdate);
    return response;
  } catch (error) {
    return error.response;
  }
};

export default UpdateTheoryApi;
